// Performans çalışmaları kapsamında genel dosyaya taşındı.
// Not: Kod yeni gizle sekme açıldığında çalışmaktadır. Daha sonra kontrol edilebilir.

if (!window.location.pathname.includes("/cart")) {
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      const drawerComponent = document.querySelector("drawer-component");
      if (drawerComponent && drawerComponent.classList.contains("active")) {
        updateCartDrawer();
      }
    }
  });
  function updateCartDrawer() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const drawerComponent = document.querySelector("drawer-component");
        if (!drawerComponent) return;

        const cartHeader = drawerComponent.querySelector(".drawer__header");
        const cartDrawerItems =
          drawerComponent.querySelector(".cart-drawer-items");

        if (!cart.items.length) {
          if (cartHeader) {
            const existingEmptyMessage = drawerComponent.querySelector(
              ".drawer__inner-empty"
            );
            if (existingEmptyMessage) {
              existingEmptyMessage.remove();
            }
            cartHeader.insertAdjacentHTML(
              "afterend",
              `
                              <div class="drawer__inner-empty">
                                  <div class="cart-drawer__warnings center">
                                      <div class="cart-drawer__empty-content">
                                          <p>
                                              <svg class="icon icon-cart" width="22px" height="20px" viewBox="0 0 22 20" xmlns="http://www.w3.org/2000/svg">
                                                  <g stroke="none" stroke-width="1" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                      <g transform="translate(-1365.000000, -69.000000)" stroke="#000000" stroke-width="1.68">
                                                          <g transform="translate(1366.000000, 70.000000)">
                                                              <path d="M17.879,17.889 L2.160,17.889 C1.764,17.889 1.431,17.591 1.387,17.197 L0.005,4.753 C-0.020,4.533 0.051,4.313 0.198,4.148 C0.346,3.983 0.557,3.889 0.778,3.889 L19.262,3.889 C19.483,3.889 19.694,3.983 19.842,4.148 C19.989,4.313 20.059,4.533 20.035,4.753 L18.652,17.197 C18.609,17.591 18.276,17.889 17.879,17.889 Z"></path>
                                                              <path d="M6.131,3.889 C6.131,1.741 7.872,0 10.020,0 C12.168,0 13.909,1.741 13.909,3.889"></path>
                                                          </g>
                                                      </g>
                                                  </g>
                                              </svg>
                                              <span class="empty-cart-message">Sepetiniz boş.</span>
                                          </p>
                                      </div>
                                  </div>
                              </div>
                          `
            );
          }
          if (cartDrawerItems) {
            cartDrawerItems.style.display = "none";
          }
        } else {
          const cartItems = cart.items;
          // console.log(cartItems);
          const cartProductIds = cartItems.map((item) =>
            item.product_id.toString()
          );

          drawerComponent.querySelectorAll(".cart-item").forEach((cartItem) => {
            const productId = cartItem.getAttribute("data-product-id");
            if (productId && !cartProductIds.includes(productId)) {
              cartItem.remove();
            }
          });

          const totalCount = cartItems.reduce(
            (total, item) => total + item.quantity,
            0
          );
          document
            .querySelectorAll(
              "drawer-component .cart-drawer__count, drawer-component .drawer__header [data-cart-count], .header__icon--cart .cart-count-bubble span:first-child"
            )
            .forEach((el) => {
              if (el) el.textContent = totalCount;
            });

          const existingEmptyMessage = drawerComponent.querySelector(
            ".drawer__inner-empty"
          );
          if (existingEmptyMessage) {
            existingEmptyMessage.remove();
          }

          if (cartDrawerItems) {
            cartDrawerItems.style.display = "block";
          }
        }
      })
      .catch((error) => console.error("Sepet verisi alınamadı", error));
  }
}
